// import Swiper JS
import Swiper, { Navigation, Pagination, Manipulation, Grid } from 'swiper';
// import Swiper styles
import 'swiper/css';
import 'swiper/css/grid';
import 'swiper/css/manipulation';
import 'swiper/css/pagination';

import { postList } from './../libs/post-list';

export function initBlogList() {
  if (window.acf) {
    window.acf.addAction('render_block_preview/type=blog-list-block', blogList);
  }
}

export function blogList() {
  if (!document.querySelector('.blog-list-block')) return;

  let blogListBlock = document.querySelector('.blog-list-block');
  let pagination = blogListBlock.querySelector('.ajax-pagination');

  let layout = document.querySelector('.blog-list-block-carousel').dataset
    .layout;

  let obj = {};
  if (layout == 2) {
    obj = {
      grid: {
        fill: 'row',
        rows: 2,
      },
      breakpoints: {
        426: {
          spaceBetween: 20,
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        769: {
          spaceBetween: 20,
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
      },
    };
  } else {
    obj = {
      breakpoints: {
        426: {
          spaceBetween: 20,
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        769: {
          spaceBetween: 0,
          slidesPerView: 2,
          slidesPerGroup: 2,
        },
        1025: {
          spaceBetween: 0,
          slidesPerView: 3,
          slidesPerGroup: 3,
        },
      },
    };
  }

  let swiper_pagination = {};

  if (!pagination) {
    swiper_pagination = {
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        },
      },
      navigation: {
        nextEl: '.swiper-button-prev',
        prevEl: '.swiper-button-next',
      },
    };
  }

  let swiper_onj = {
    modules: [Navigation, Pagination, Manipulation, Grid],
    allowTouchMove: false,
    slidesPerView: 1,
    slidesPerGroup: 1,
    ...obj,
    ...swiper_pagination,
    on: {
      init() {
        postList();
      },
      breakpoint(swiper) {
        postsPerPageUpdated(swiper);
        updatePagination(swiper, 1);
      },
    },
  };

  const swiper = new Swiper('.blog-list-block-carousel', swiper_onj);

  blogListBlock.addEventListener('click', (e) => {
    if (
      e.target &&
      e.target.classList.contains('page-numbers') &&
      e.target.tagName == 'A'
    ) {
      e.preventDefault();
      let v = e.target;

      let page = 1;
      let totalPages = pagination.dataset.totalPages;
      let currentPage = pagination.dataset.currentPage;
      let postsPerPage = pagination.dataset.postsPerPage;
      let categories = pagination.dataset.categories;
      let postsLoaded = blogListBlock.querySelectorAll('article').length;

      if (v.classList.contains('next')) {
        page = currentPage * 1 + 1;
      } else if (v.classList.contains('prev')) {
        page = currentPage * 1 - 1;
      } else {
        page = v.innerHTML;
      }

      pagination.dataset.currentPage = page;

      let data = {
        action: 'blog_list',
        page: page,
        total_pages: totalPages,
        posts_loaded: postsLoaded,
        posts_per_page: postsPerPage,
        categories: categories,
      };

      fetch(ajax_object.ajaxurl + '?action=blog_list', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((json) => {
          let multiplier = layout == 2 ? 2 : 1;

          swiper.appendSlide(json.posts);
          swiper.updateSlides();
          postList();

          if (v.classList.contains('next')) {
            swiper.slideNext();
          } else if (v.classList.contains('prev')) {
            swiper.slidePrev();
          } else {
            swiper.slideTo((page * postsPerPage - postsPerPage) / multiplier);
          }
          updatePagination(swiper, page);
        });
    }
  });

  function postsPerPageUpdated(swiper) {
    if (!pagination) return;

    let multiplier = layout == 2 ? 2 : 1;

    let breakpoint = 0;
    for (var i = 0; i < Object.keys(swiper.params.breakpoints).length; i++) {
      let value = Object.keys(swiper.params.breakpoints)[i];
      if (window.matchMedia(`(min-width: ${value}px)`).matches) {
        if (parseInt(value) > parseInt(breakpoint)) {
          breakpoint = value;
        }
      }
    }

    if (breakpoint > 0) {
      pagination.dataset.postsPerPage =
        swiper.params.breakpoints[breakpoint].slidesPerView * multiplier;
    } else {
      pagination.dataset.postsPerPage =
        swiper.params.slidesPerView * multiplier;
    }
  }

  function updatePagination(swiper, page) {
    if (!pagination) return;

    let multiplier = layout == 2 ? 2 : 1;
    let postsPerPage = pagination.dataset.postsPerPage;
    let categories = pagination.dataset.categories;

    let data = {
      action: 'blog_list_pagination',
      posts_per_page: postsPerPage,
      page: page,
      base: window.location.href,
      categories: categories,
    };

    fetch(ajax_object.ajaxurl + '?action=blog_list_pagination', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((json) => {
        swiper.slideTo((page * postsPerPage - postsPerPage) / multiplier);
        pagination.innerHTML = json.pagination;
      });
  }
}
